export enum ActivationRangeOptions {
  'NOW' = 'NOW',
  'LATER' = 'LATER'
}
